module.exports = __webpack_public_path__ + "505f3e3167566bd69933bcd575ee9f65.fbx";